import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";

const ListTableSection = ({ controls, children, sx }) => (
  <Box sx={{ minWidth: 0, pt: 2.5, ...sx }}>
    {controls ? <Box sx={{ mb: 2.5 }}>{controls}</Box> : null}
    {children}
  </Box>
);

ListTableSection.propTypes = {
  controls: PropTypes.node,
  children: PropTypes.node.isRequired,
  sx: PropTypes.object,
};

export default ListTableSection;
